import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%'
  },
  main: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(2),
  },
  footer: {
    padding: theme.spacing(3, 2),
    textAlign: 'center',
    marginTop: 'auto',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[800],
  },
}));

export default function StickyFooter() {
  // TODO styling for mobile usage (text and height etc.)
  const classes = useStyles();
  return (
    <React.Fragment>
      <footer className={classes.footer}>
        <Container maxWidth="lg">
          <Typography variant="body1">
          
            Please direct questions, bug reports, etc. to <a href = "mailto: commonocean@lists.lrz.de">commonocean@lists.lrz.de</a>
          {/* Contact
            <a target="_blank" rel="noopener noreferrer" href={process.env.REACT_APP_FORUM_URL}> forum</a>.<br />
          */}
          <br />
            <Link to="/privacy-policy">Privacy Policy</Link>
          </Typography>
        </Container>
      </footer>
    </React.Fragment>
  );
}